import { createContext, useContext, useState, useCallback, type ReactNode } from 'react';

interface AppDownloadContextValue {
  isOpen: boolean;
  openModal: () => void;
  closeModal: () => void;
}

const AppDownloadContext = createContext<AppDownloadContextValue | null>(null);

export function AppDownloadProvider({ children }: { children: ReactNode }) {
  const [isOpen, setIsOpen] = useState(false);

  const openModal = useCallback(() => setIsOpen(true), []);
  const closeModal = useCallback(() => setIsOpen(false), []);

  return (
    <AppDownloadContext.Provider value={{ isOpen, openModal, closeModal }}>
      {children}
    </AppDownloadContext.Provider>
  );
}

export function useAppDownload() {
  const ctx = useContext(AppDownloadContext);
  if (!ctx) throw new Error('useAppDownload must be used within AppDownloadProvider');
  return ctx;
}